import { sanitize } from 'isomorphic-dompurify';

/**
 * @param {SafeHTMLProps} props
 * @returns {React.ReactElement} The rendered component
 */
const SafeHTML = ({ html, as: Component = 'div', ...rest }) => {
  const sanitizedHTML = sanitize(html ?? '', {
    ADD_ATTR: ['target'],
  });
  return (
    <Component {...rest} dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />
  );
};

export default SafeHTML;
